import React, { CSSProperties, ReactNode } from 'react';

import classes from './Alert.module.scss';

export enum EAlertColor {
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  PRIMARY = 'PRIMARY'
}

interface IProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  color?: EAlertColor;
}

const Alert: React.FC<IProps> = ({ children, className, style, color }) => {
  const classNames = [classes.Container];
  if (className) {
    classNames.push(className);
  }

  switch(color) {
    case EAlertColor.PRIMARY:
      classNames.push(classes.Primary);
      break;
    case EAlertColor.SUCCESS:
      classNames.push(classes.Success);
      break;
    default: 
      classNames.push(classes.Danger);
      break;
  }

  return <div style={style} className={classNames.join(" ")}>{children}</div>;
};

export default Alert;
